__turbopack_context__.v({
  "divider": "apDodq_divider",
  "inverted": "apDodq_inverted",
  "padded": "apDodq_padded",
  "section__container": "apDodq_section__container",
  "section__content": "apDodq_section__content",
  "section__heading": "apDodq_section__heading",
  "ypadded": "apDodq_ypadded",
});
